import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useCookieConsent } from '../../contexts/CookieConsentContext';

export default function CookieConsentBanner() {
  const { decided, ready, acceptAll, rejectAll } = useCookieConsent();
  const { pathname } = useLocation();
  const visible = ready && !decided && pathname !== '/cookies';

  useEffect(() => {
    if (visible) {
      document.body.classList.add('rwm-cookie-banner-open');
      return () => document.body.classList.remove('rwm-cookie-banner-open');
    }
    document.body.classList.remove('rwm-cookie-banner-open');
    return undefined;
  }, [visible]);

  if (!visible) {
    return null;
  }

  return (
    <div
      className="rwm-cookie-banner"
      role="dialog"
      aria-label="Cookie consent"
      data-testid="rwm-cookie-banner"
    >
      <div className="rwm-cookie-banner__inner container-xl">
        <p className="rwm-cookie-banner__text mb-3 mb-md-0">
          We use essential cookies to keep the platform running. We&apos;d also like to use
          analytics cookies (Google Analytics 4) to understand how visitors use the site. You can
          change your preference at any time on our{' '}
          <Link to="/cookies" className="rwm-cookie-banner__link">
            Cookie Policy
          </Link>{' '}
          page.
        </p>
        <div className="rwm-cookie-banner__actions d-flex flex-wrap gap-2">
          <Button
            type="button"
            variant="info"
            className="text-white"
            onClick={() => acceptAll()}
            data-testid="rwm-cookie-accept-all"
          >
            Accept All
          </Button>
          <Button
            type="button"
            variant="outline-light"
            onClick={() => rejectAll()}
            data-testid="rwm-cookie-reject-all"
          >
            Essential Only
          </Button>
        </div>
      </div>
    </div>
  );
}
